module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEdSURBVEhL7ZRNTgJBEIWHLS44gjhX0cQEjdcEPYCJez2FCQnoxqBbltN8VfXMOI2EmYkBF3zJS1OvfprpaShO/D+qqrpB7+gVXco2/wU9KyxSSleqsdqJ7P1Q/EZzJ+hZqn0/h9hgYpugxhHlMPf7iJboWnZ/4rumpPDv0fz+G1gzj7rzRvh0UNgd9W+9MOILNFPa8lPzlG6P+h1Z5pUM+wy3Rl6psnZEa5DHu2CjNVqge3SLNfBhvxEtQR63hU0eWUY+MCdKgjzuAps8sWw/SaSDPO6KHZcP/YlyjizzxhSvwq3B+0DnfByy+i8/MgHxVCNqlLNk45pilegB/0uyF9q4psR33iyI50rVKNHrf4WeM58siNdKnTg6RbEBJanQ/gcUw5sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-plumbing/light/24.png
// module id = 2360
// module chunks = 2